import type { PickemDto } from '@/api/backoffice-schemas';
import { PickedPickemsList } from '@/components/pickems/betting/PickedPickemsList';
import type { SupportedGame } from '@/config/supportedGames';
import type { Tournament } from '@/types/tournament';
import { PickemBetTabsCommon } from '../betting/PickemBetTabsCommon';
import { TournamentBetHistory } from './TournamentBetHistory';

interface TournamentsBetsTabsProps {
  selectedPickems: PickemDto[];
  totalPickems: number;
  tournament: Tournament;
  game: SupportedGame;
  onClearAll: () => void;
  onRemove: (pickemId: string) => void;
  onSuccess: () => void;
}

export const TournamentsBetsTabs = ({
  selectedPickems,
  totalPickems,
  tournament,
  game,
  onClearAll,
  onRemove,
  onSuccess,
}: TournamentsBetsTabsProps) => {
  return (
    <PickemBetTabsCommon
      history={<TournamentBetHistory game={game} tournament={tournament} />}
      list={
        <PickedPickemsList
          onClearAll={onClearAll}
          onRemove={onRemove}
          onSuccess={onSuccess}
          selectedPickems={selectedPickems}
          totalPickems={totalPickems}
        />
      }
    />
  );
};
